export default function getUserLocation(setUserLocation) {
    console.log("Get user location");

    // Default fallback location (you can customize this)
    const defaultLocation = {
        latitude: 37.7749, // San Francisco coordinates
        longitude: -122.4194,
    };

    if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { coords } = position;
                const { latitude, longitude } = coords;
                setUserLocation({ latitude, longitude });
            },
            (error) => {
                console.log("Location access denied or failed:", error.message);
                // Use fallback location when user denies permission or other errors occur
                setUserLocation(defaultLocation);
            },
            {
                timeout: 10000, // 10 second timeout
                enableHighAccuracy: false,
            }
        );
    } else {
        console.log("Geolocation not supported, using fallback location");
        setUserLocation(defaultLocation);
    }
}
